/** Primary / secondary conversion CTAs — use site-wide for consistency. */
export const CTA_PRIMARY_LABEL = 'Book Free Consultation';
export const CTA_PRIMARY_PATH = '/service-request';

export const CTA_SECONDARY_LABEL = 'Explore Services';
export const CTA_SECONDARY_PATH = '/services';

/** Product cards: demo / discovery (same funnel as consultation). */
export const CTA_DEMO_LABEL = 'Request Demo';
export const CTA_DEMO_PATH = '/service-request';
